
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToQuote = () => {
    const element = document.getElementById('quote');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(15, 58, 46, 0.7), rgba(15, 58, 46, 0.7)), url('https://public.readdy.ai/ai/img_res/e21a571ac36ee9d833b6e7fbe3dd779f.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          <h1 
            className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight"
            style={{ fontFamily: 'Playfair Display, serif' }}
          >
            Health Insurance{' '}
            <span className="text-yellow-400">Shouldn't Be</span>{' '}
            Stressful
          </h1>
          
          <p className="text-xl md:text-2xl text-gray-200 mb-8 leading-relaxed max-w-3xl mx-auto">
            Customized health plans for individuals, families, and small businesses — 
            tailored to your needs and budget.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              onClick={scrollToQuote}
              size="lg"
              variant="secondary"
              className="text-lg px-10 py-4"
            >
              <i className="ri-file-text-line mr-2"></i>
              Get a Quote
            </Button>
            
            <Button 
              onClick={() => window.open('https://calendly.com/nicholasdearaujo1/30min', '_blank')}
              size="lg"
              variant="outline"
              className="text-lg px-10 py-4 border-white text-white hover:bg-white hover:text-green-800"
            >
              <i className="ri-calendar-line mr-2"></i>
              Book Consultation
            </Button>
          </div>
          
          <div className="mt-12 flex flex-col sm:flex-row justify-center items-center gap-8 text-white">
            <div className="flex items-center space-x-2">
              <i className="ri-shield-check-line text-yellow-400 text-xl"></i>
              <span>Licensed in 30+ States</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-user-heart-line text-yellow-400 text-xl"></i>
              <span>Personalized Service</span>
            </div>
            <div className="flex items-center space-x-2">
              <i className="ri-money-dollar-circle-line text-yellow-400 text-xl"></i>
              <span>Affordable Options</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-2xl"></i>
      </div>
    </section>
  );
}
